import axios from "axios";
import { toast } from "sonner";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API_BASE = `${BACKEND_URL}/api`;

const api = axios.create({ baseURL: API_BASE });

api.interceptors.request.use((config) => {
  const token = localStorage.getItem("cf_token");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

// Track last cap-toast so rapid-fire calls don't spam
let lastCapToastAt = 0;

api.interceptors.response.use(
  (r) => r,
  (err) => {
    const status = err?.response?.status;
    if (status === 401) {
      localStorage.removeItem("cf_token");
      localStorage.removeItem("cf_user");
      if (!window.location.pathname.startsWith("/login") && !window.location.pathname.startsWith("/signup")) {
        window.location.href = "/login";
      }
    } else if (status === 402) {
      const detail = err.response?.data?.detail;
      // Structured cap detail from backend usage.py
      if (detail && typeof detail === "object" && detail.code === "cap_reached") {
        const now = Date.now();
        if (now - lastCapToastAt > 2500) {
          lastCapToastAt = now;
          toast.error(detail.message || `Free tier limit reached for ${detail.meter_label || detail.meter}.`, {
            action: {
              label: "Upgrade",
              onClick: () => { window.location.href = detail.upgrade_url || "/pricing"; },
            },
            duration: 8000,
          });
        }
      }
    }
    return Promise.reject(err);
  },
);

export function formatApiErrorDetail(detail) {
  if (detail == null) return "Something went wrong. Please try again.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail
      .map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e)))
      .filter(Boolean)
      .join(" ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}

export default api;
